import makeApiRequest from './makeApiRequest';

const getFairInfo = () => {
	const getApiRequest = makeApiRequest('GET');

	const getFair = async (apiBase: string, fair: string) => getApiRequest(`${apiBase}/public/fairs/${fair}`, {});

	return [getFair];
};

export default getFairInfo;
